import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
// @ts-ignore
import Select from '@r1-frontend/ui-react/components/select/titleSelect';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const StyledTicketWrap = styled.div`
    flex-direction: column;
    width: 100%;

    & > div {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const StyledTicket = styled.div`
    background-color: ${COLORS.BgSurface};
    display: flex;
    flex-direction: column;
    max-width: 480px;
    width: 100%;
    border-radius: ${BorderRadius.componentRadius};

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: none;
    }
`;

export const StyledTicketTitle = styled.p`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H5};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H3};
    }

    @media (max-width: 432px) {
        ${FONTS.H5};
    }
`;

export const StyledTicketList = styled.div<{ marginTop?: string, marginTopMobile?: string }>`
    display: flex;
    flex-direction: column;
    row-gap: 8px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-right: 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-right: 0;
    }
`;

interface TicketItemProps {
    type: 'mobileRow' | 'mobileColumn',
    marginBottom?: string,
    isEquipment?: boolean,
    successStatus?: boolean,
    isLeasingPrice?: boolean,
}

export const StyledTicketItem = styled.div<TicketItemProps>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: ${props => (props.isEquipment && props.type === 'mobileColumn') ? '8px' : props.isEquipment ? '0' : '10px'};
    margin-bottom: ${props => props.marginBottom ?? '0'};

    ${p => p.isEquipment && css`
        &:last-child {
            border-top: 2px solid ${COLORS.TextSecondary};
            margin-top: 24px;
        }
   `}

   ${p => p.successStatus && css`
        &:last-child {
            border-top: none;
            margin-top: 0;
        }
   `}

   ${p => p.successStatus && css`
        &:last-child {
            margin-top: ${(p: TicketItemProps) => p.isLeasingPrice ? '8px' : '24px'};
        }
   `};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        justify-content: ${(p: TicketItemProps) => (!p.isEquipment && p.type === 'mobileColumn') ? 'flex-start' : 'space-between'};
        align-items: flex-start;
        flex-direction: ${(p: TicketItemProps) => (!p.isEquipment && p.type === 'mobileColumn') ? 'column' : 'row'};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        justify-content: space-between;
        align-items: normal;
        flex-direction: row;
    }
  
`;

interface TicketItemTextProps {
    isName: boolean,
    type: 'title' | 'final' | 'item' | 'withPlan',
    isEquipment?: boolean,
    successStatus?: boolean,
    isLeasingPrice?: boolean,
}

export const StyledTicketItemText = styled.p`
    display: flex;
    flex-direction: column;
    max-width: ${(p: TicketItemTextProps) => p.isName ? '300px' : 'none'};
    
    ${(p: TicketItemTextProps) => (p.type === 'title' || p.type === 'final') ? FONTS.M : FONTS.S};

    color: ${(p: TicketItemTextProps) => (p.type === 'title' || p.type === 'final') ? COLORS.TextPrimary : COLORS.TextInfo};

    ${p => p.isEquipment && p.type === 'final' && css`
        margin-top: 8px;
   `}

   ${p => p.isEquipment && p.type === 'title' && css`
        margin-top: 24px;
        flex-direction: row;
  `}

   ${p => p.successStatus && css`
        margin-top: ${(p: TicketItemTextProps) => p.isLeasingPrice ? '24px' : '0'};
  `}

   ${p => p.isEquipment && p.type === 'final' && css`
        ${FONTS.H4};
  `};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${p => !p.isEquipment && css`
            ${FONTS.XS};
       `}
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${p => !p.isEquipment && css`
            ${FONTS.S};
       `}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${(p: TicketItemTextProps) => {
        switch (!p.isEquipment && p.type) {
            case 'final': {
                return FONTS.S;
            }
            case 'item': {
                return FONTS.XS;
            }
            case 'title': {
                return FONTS.XS;
            }
        }
    }};
    }
`;

export const StyledTicketItemWithActionNameBlock = styled.div<{ isEquipment?: boolean }>`
    display: flex;
    flex-direction: column;
    max-width: ${p => p.isEquipment ? '260px' : '282px'};
    width: 100%;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${p => p.isEquipment && css`
            max-width: 200px;
       `}
    }
`;

export const StyledTicketItemWithActionName = styled.div<{ isEquipment?: boolean }>`
    ${FONTS.S};
    color: ${COLORS.TextInfo};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${p => !p.isEquipment && css`
            ${FONTS.XS};
       `}
        padding-right: 20px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.S};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const StyledTicketItemWithActionPlan = styled(Select)`
    max-width: 260px;

    & div:nth-child(2) > div:last-child {
        display: none;
    }
`;

export const StyledTicketItemWithActionValue = styled.p`
    ${FONTS.M};
    color: ${COLORS.TextPrimary};
`;

export const StyledTicketItemWithActionButton = styled.div<{ isLaptop?: boolean }>`
    position: absolute;
    cursor: pointer;
    right: -29px;
    top: 4px;

    img {
        width: 16px;
        height: 16px;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        right: ${p => p.isLaptop ? '-29px' : '0'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        right: 0;
    }
`;

export const StyledPlanSelect = styled(Select)`
    margin-bottom: 10px;
`;

export const Button = styled(BaseButton)`
    width: 100%;
    margin-top: 24px;
`;

export const LkWrap = styled.div`
    padding: 0 24px;
`;
